import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getActivityText, getActivityStatusIcon } from '../../helpers'

const ActivityItem = ({ activities = [], timezone, viewAllLink }) => {
  const { t } = useTranslation(['rewards-dashboard'])
  const navigate = useNavigate()
  return (
    <div className="rewards-dashboard-item">
      <div className="rewards-dashboard-item__actions">
        <span className="rewards-dashboard-item__actions__title">
          {t('rewards-dashboard:activityItem.title')}
        </span>
        {viewAllLink && (
          <button className="button" onClick={() => navigate(viewAllLink)}>
            {t('rewards-dashboard:activityItem.viewAllButton')}
          </button>
        )}
      </div>
      {activities.length > 0 ? (
        <div className="rewards-dashboard-item__activities">
          <table>
            <tbody>
              {activities.map((activity) => (
                <tr key={activity.id}>
                  <td className="rewards-dashboard-item__activities__icon">
                    {getActivityStatusIcon(activity.status || activity.type)}
                  </td>
                  <td>{getActivityText(activity, timezone, t)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        t('rewards-dashboard:leaderBoard.noResultsYet')
      )}
    </div>
  )
}

ActivityItem.propTypes = {
  activities: PropTypes.array,
  timezone: PropTypes.string,
  viewAllLink: PropTypes.string,
}

export default ActivityItem
